/* eslint-disable no-empty-pattern */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getRmData = createAsyncThunk(
  "rm/getRmData",
  async (query = {}) => {
    try {
      const { usersUnderRmList, forBusiness, forInvestor } = query;

      const params = {
        ...(usersUnderRmList !== undefined && { usersUnderRmList }),
        ...(forBusiness !== undefined && { forBusiness }),
        ...(forInvestor !== undefined && { forInvestor }),
      };

      const response = await axios.get("/api/admin/v1/rm", { params });
      return response.response;
    } catch (err) {
      const message = err?.response?.response?.message || err?.message || "Failed to fetch RM table view";
      throw new Error(message);
    }
  });

export const Deactivate = createAsyncThunk(
  "rm/Deactivate",
  async (rmUserId, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/deactivateRM`, {
        rmUserId: rmUserId,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const RMtableDetailView = createAsyncThunk(
  "rm/RMtableDetailView",
  async (rmUserId) => {
    const response = await axios.get(
      `/api/admin/usersAssignedToRM?rmUserId=${rmUserId}`
    );
    return response.response;
  }
);

export const getAssginRM = createAsyncThunk("rm/getAssginRM", async () => {
  const response = await axios.get(`/api/admin/getAssginRM`);
  return response.response;
});

export const ReAssignToRm = createAsyncThunk(
  "rm/ReAssignToRm",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/reAssignToRm", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const newassignRM = createAsyncThunk(
  "rm/newassignRM",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/assignToRm", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const RmSlice = createSlice({
  name: "rm",
  initialState: {
    dropdownData: {},
    reAssignRM: {},
    rmTabledata: [],
    rmdetailData: [],
    deactivate: {},
    loading: false,
    error: null,
    assignRmLoading: false,
    deactivateRmLoading: false,
  },

  extraReducers: (builder) => {
    builder.addCase(getAssginRM.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAssginRM.fulfilled, (state, action) => {
      state.loading = false;
      state.dropdownData = action.payload;
      state.error = "";
    });
    builder.addCase(getAssginRM.rejected, (state, action) => {
      state.loading = false;
      state.dropdownData = [];
      state.error = action.payload;
    });

    builder.addCase(ReAssignToRm.pending, (state) => {
      state.assignRmLoading = true;
      state.error = "";
    });
    builder.addCase(ReAssignToRm.fulfilled, (state, action) => {
      state.assignRmLoading = false;
      state.error = "";
    });
    builder.addCase(ReAssignToRm.rejected, (state, action) => {
      state.assignRmLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getRmData.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getRmData.fulfilled, (state, action) => {
      state.loading = false;
      state.rmTabledata = action.payload;
    });
    builder.addCase(getRmData.rejected, (state, action) => {
      state.loading = false;
      state.rmTabledata = [];
      state.error = action.payload;
    });

    builder.addCase(Deactivate.pending, (state) => {
      state.deactivateRmLoading = true;
      state.error = "";
    });
    builder.addCase(Deactivate.fulfilled, (state, action) => {
      state.deactivateRmLoading = false;
      state.error = "";
    });
    builder.addCase(Deactivate.rejected, (state, action) => {
      state.deactivateRmLoading = false;
      state.error = action.payload;
    });

    builder.addCase(RMtableDetailView.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(RMtableDetailView.fulfilled, (state, action) => {
      state.loading = false;
      state.rmdetailData = action.payload;
    });
    builder.addCase(RMtableDetailView.rejected, (state, action) => {
      state.loading = false;
      state.rmdetailData = [];
      state.error = action.error.message;
    });

    builder.addCase(newassignRM.pending, (state) => {
      state.assignRmLoading = true;
      state.error = "";
    });
    builder.addCase(newassignRM.fulfilled, (state, action) => {
      state.assignRmLoading = false;
      state.error = "";
    });
    builder.addCase(newassignRM.rejected, (state, action) => {
      state.assignRmLoading = false;
      state.error = action.payload;
    });
  },

  reducers: {},
});

export const { } = RmSlice.actions;

export default RmSlice.reducer;
